import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as AuthenticationActions from '@planone/bau365/data-access-authentication';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { of, switchMap, withLatestFrom } from 'rxjs';

@Injectable()
export class AuthenticationEffects {
  authenticationStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthenticationActions.changed),
      withLatestFrom(this.authenticationFacade.authenticated$),
      withLatestFrom(this.authenticationFacade.authencationTokenSub$),
      switchMap(([[action, authenticated], authenctionTokenSub]) =>
        of(
          FeatureTrackingGoogleAnalytics.push({
            user_id: action.sub ?? authenctionTokenSub,
            loggedIn: action.authenticated || authenticated ? 'yes' : 'no',
          }),
          FeatureTrackingSnowplow.setUserId({
            tokenSub: action.sub ?? authenctionTokenSub,
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private store: Store,
    private authenticationFacade: AuthenticationFacade
  ) {}
}
